<template>
  <Section
    @back="$emit('back')"
    title="配信対象設定"
    margin
    tip-message="配信対象設定に戻る"
  >
    <template v-if="menuSetting.uploadFile.fileName !== ''">
      <v-subheader>入稿ファイル</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>
          {{ menuSetting.uploadFile.fileName }}
        </v-flex>
      </v-layout>
    </template>
    <template v-if="menuSetting.orderDescription.memo !== ''">
      <v-subheader>備考</v-subheader>
      <v-layout pl-4>
        <v-flex xs9>
          {{ menuSetting.orderDescription.memo }}
        </v-flex>
      </v-layout>
    </template>
  </Section>
</template>

<script>
import Section from './CampaignModalPageConfirmSection'

export default {
  name: 'CampaignModalPageConfirmCustomTarget',
  components: {
    Section,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting
    },
  },
}
</script>
